import { API } from "../api/axios";
const END_POINT = "/levels";

class LevelsService {
    getAll(params) {
        return API.get(END_POINT, params);
    }
}

export default new LevelsService();
